import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const PopularArticles = () => {
  const popularSlugs = [
    'bika-android-xiazai-jiaocheng',
    'bika-zhuce-jiaocheng-xiangjie',
    'bika-gongneng-yuedu-moshi',
    'bika-wufa-dakai-jiejue',
    'bika-duanpian-xiazai-jiqiao',
    'bika-tuijian-suanfa-jiedu',
  ];

  const popularArticles = popularSlugs
    .map((slug) => articles.find((a) => a.slug === slug))
    .filter(Boolean);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              热门教程文章
            </h2>
            <p className="text-sm text-foreground-500">
              最受新用户欢迎的哔咔漫画使用教程
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-1.5 rounded-full text-xs bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {popularArticles.map((article) => {
            if (!article) return null;
            const cat = categories.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200/70 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    {cat && (
                      <span className="text-xs px-2 py-1 rounded-full bg-accent-100/80 text-accent-700 whitespace-nowrap">
                        {cat.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400 flex items-center space-x-1">
                      <i className="ri-time-line"></i>
                      <span>{article.readTime}</span>
                    </span>
                  </div>
                  <h3 className="text-base font-heading text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="text-xs text-foreground-400">{article.date}</span>
                    <span className="text-xs text-primary-500 flex items-center space-x-1 group-hover:translate-x-1 transition-transform">
                      <span>阅读全文</span>
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/xiazai-jiaocheng"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <span>浏览全部教程</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularArticles;